import React, { useState } from 'react';
import { Accordion, AccordionContent, AccordionTitle, Icon, Label, Table } from 'semantic-ui-react';

// ─── RoadblocksTable ──────────────────────────────────────────────────────────

export const RoadblocksTable = ({ roadblocks }) => {
    const [open, setOpen] = useState(true);

    if (!roadblocks || roadblocks.length === 0) return null;

    return (
        <Accordion
            fluid
            styled
            style={{ marginBottom: '1rem', boxShadow: 'none', border: '1px solid #f0d9b5' }}
        >
            <AccordionTitle
                active={open}
                onClick={() => setOpen(!open)}
                style={{ background: '#fdf6ec' }}
            >
                <Icon name="dropdown" />
                <Icon name="warning sign" color="orange" />
                Open Roadblocks&nbsp;
                <Label color="orange" circular size="tiny">{roadblocks.length}</Label>
            </AccordionTitle>

            <AccordionContent active={open}>
                <div style={{ overflowX: 'auto' }}>
                    <Table basic="very" compact unstackable style={{ fontSize: '0.88rem' }}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell scope="col">Roadblock Type</Table.HeaderCell>
                                <Table.HeaderCell scope="col">Date Reported</Table.HeaderCell>
                                <Table.HeaderCell scope="col">Description</Table.HeaderCell>
                                <Table.HeaderCell scope="col">Submitted By</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {roadblocks.map(rb => (
                                <Table.Row key={rb.id}>
                                    <Table.Cell>{rb.roadblockTypeDisplay || rb.roadblockType || '—'}</Table.Cell>
                                    <Table.Cell>{rb.date || '—'}</Table.Cell>
                                    <Table.Cell style={{ maxWidth: '320px' }}>{rb.description || '—'}</Table.Cell>
                                    <Table.Cell>{rb.submittedBy || '—'}</Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </div>
            </AccordionContent>
        </Accordion>
    );
};
